// extracted by mini-css-extract-plugin
module.exports = {"statusMessage":"OutOfStockStatusMessage_statusMessage__az8g_"};